import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import FormContainer from "../../../../../../common/components/form_container";
import DefaultFormInput from "../../../../../../common/components/default_form_input";
import { useEffect } from "react";
import PrimaryButton from "../../../../../../common/components/primary_button";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import { LogTipoTabela } from "../../../../../../common/utils/log_tabela_tipo";
import { ChecklistEntregaAmbienteModel } from "../../../../domain/models/checklist_entrega_ambiente";
import { ChecklistEntregaAmbienteCadastroForm, ChecklistEntregaAmbienteCadastroSchema, defaultChecklistEntregaAmbienteCadastroForm } from "../../../schemas/checklist_entrega_ambiente_lista/checklistEntregaAmbienteCadastro";

type props = {
    open: boolean,
    saving: boolean,
    loading: boolean,
    selectedChecklistEntregaAmbiente?: ChecklistEntregaAmbienteModel | null,

    handleOpenChangeHistory: (idTabela: number | null, tipoTabela: LogTipoTabela | null) => void
    onClose: () => void,
    onSubmit: (form: ChecklistEntregaAmbienteCadastroForm) => void,
}

export const CadastroChecklistEntregaAmbienteModal = ({
    open,
    saving,
    loading,
    selectedChecklistEntregaAmbiente,

    handleOpenChangeHistory,
    onClose,
    onSubmit,
}: props) => {

    const hookFormCadastro = useForm<ChecklistEntregaAmbienteCadastroForm>({
        mode: "onSubmit",
        reValidateMode: "onSubmit",
        defaultValues: defaultChecklistEntregaAmbienteCadastroForm,
        resolver: zodResolver(ChecklistEntregaAmbienteCadastroSchema),
    });

    useEffect(() => {
        if (selectedChecklistEntregaAmbiente) {
            hookFormCadastro.setValue('idChecklistEntrega', selectedChecklistEntregaAmbiente.idChecklistEntrega);
            hookFormCadastro.setValue('ordem', selectedChecklistEntregaAmbiente.ordem ?? '');
            hookFormCadastro.setValue('descricao', selectedChecklistEntregaAmbiente.descricao ?? '');
        } else {
            hookFormCadastro.reset(defaultChecklistEntregaAmbienteCadastroForm);
        }
        if (!open) {
            hookFormCadastro.reset(defaultChecklistEntregaAmbienteCadastroForm);
        }
    }, [selectedChecklistEntregaAmbiente, open, hookFormCadastro]);


    return (
        <BaseFormControlledModal
            open={open}
            saving={saving}
            loading={loading}
            title="Cadastro de Ambiente (Sala, cozinha, banheiro, outros)"
            onClose={onClose}
            leftButtonSlot={
                selectedChecklistEntregaAmbiente &&
                <PrimaryButton
                    buttonColor="yellow"
                    onClick={() => handleOpenChangeHistory(selectedChecklistEntregaAmbiente?.idChecklistEntregaAmbiente ?? null, LogTipoTabela.CHECKLIST_ENTREGA_AMBIENTE)}>
                    <span className="text-xs">
                        Historico de alterações
                    </span>
                </PrimaryButton>}
            onSubmit={hookFormCadastro.handleSubmit(onSubmit)}>

            <FormContainer title={"Informações"} arrangement="fullRow">
                <>
                    <DefaultFormInput
                        name='ordem'
                        label='Ordem'
                        readOnly={false}
                        required={true}
                        reactHookForm={hookFormCadastro}

                    />

                    <DefaultFormInput
                        name={'descricao'}
                        label="Ambiente"
                        readOnly={false}
                        required={true}
                        multiline={true}
                        rows={5}
                        minRows={4}
                        maxRows={10}
                        reactHookForm={hookFormCadastro}
                    />

                </>
            </FormContainer>
        </BaseFormControlledModal>
    );
}